import { render, staticRenderFns } from "./SecondHome.vue?vue&type=template&id=aa310e5a&scoped=true"
import script from "./SecondHome.vue?vue&type=script&lang=js"
export * from "./SecondHome.vue?vue&type=script&lang=js"
import style0 from "./SecondHome.vue?vue&type=style&index=0&id=aa310e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa310e5a",
  null
  
)

export default component.exports